"use client";

import type { EmailInputStepProps } from "./types";
import { EmailInputStepDesktop } from "./steps/EmailInputStepDesktop";
import { EmailInputStepMobile } from "./steps/EmailInputStepMobile";
import { EmailInputStepPopup } from "./steps/EmailInputStepPopup";

export function EmailInputStep(props: EmailInputStepProps) {
  switch (props.variant) {
    case "desktop":
      return <EmailInputStepDesktop {...props} />;
    case "mobile":
      return <EmailInputStepMobile {...props} />;
    case "popup":
      return <EmailInputStepPopup {...props} />;
    default:
      return <EmailInputStepMobile {...props} />;
  }
}
